// Define the coverage area center point
import { Point } from '../../../system/location';

export const FALLBACK_COVERAGE_CENTER: Point = {
  x: 38.9072, // DC/MD border latitude
  y: -77.0369, // DC/MD border longitude
};

export const LABELS = {
  realistAddressSearch: 'Enter Address',
  standardAddressSearch: 'Enter Address/Tax ID',
};
